var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237 73",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    fill: "#0091BD",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    transform: "translate(-277.75,-269.45)",
    d: "M331.4,271.8h15.9v68.1h-15.9v-7.1c-7,8.1-15.5,9.2-20.4,9.2c-21,0-33-17.5-33-36.2c0-22.2,15.2-35.8,33.2-35.8 c5,0,13.8,1.3,20.2,9.7V271.8z M294.2,306.1c0,11.8,7.4,21.7,18.9,21.7c10,0,19.3-7.3,19.3-21.5c0-14.9-9.2-22-19.3-22 C301.6,284.3,294.2,294,294.2,306.1z M366.1,271.8H382v6.1c1.8-2.1,4.4-4.4,6.6-5.7c3.1-1.8,6.1-2.3,9.7-2.3c3.9,0,8.1,0.6,12.5,3.2 l-6.5,14.4c-3.6-2.3-6.5-2.4-8.1-2.4c-3.4,0-6.8,0.5-9.9,3.7c-4.4,4.7-4.4,11.2-4.4,15.7v35.3h-15.9V271.8z M421,271.8h15.9v6.3 c5.3-6.5,11.6-8.1,16.8-8.1c7.1,0,13.8,3.4,17.6,10c5.7-8.1,14.2-10,20.2-10c8.3,0,15.5,3.9,19.4,10.7c1.3,2.3,3.6,7.3,3.6,17.2 v42.1h-15.9v-37.5c0-7.6-0.8-10.7-1.5-12.1c-1-2.6-3.4-6-9.1-6c-3.9,0-7.3,2.1-9.4,5c-2.8,3.9-3.1,9.7-3.1,15.5v35.1h-15.9v-37.5 c0-7.6-0.8-10.7-1.5-12.1c-1-2.6-3.4-6-9.1-6c-3.9,0-7.3,2.1-9.4,5c-2.8,3.9-3.1,9.7-3.1,15.5v35.1H421V271.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArm);
export default __webpack_public_path__ + "static/media/Arm.02d72c85eb5062b2187877eb6ce99a1c.svg";
export { ForwardRef as ReactComponent };